import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material';

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: 'flex',
    height: '100%',
    flex: 1,
  },

  button: {
    color: theme.palette.text.primary,
    textTransform: 'capitalize',
    padding: theme.spacing(1, 2),
    height: '100%',

    '&:hover': {
      backgroundColor: 'transparent',
    },
  },

  menu: {
    '& .MuiList-root': {
      width: theme.spacing(50),
    },

    '& .MuiPaper-root': {
      width: theme.spacing(50),
      borderRadius: theme.spacing(0),
      height: `calc(100% - ${theme.spacing(7.5)})`,
      background: theme.palette.sidebar.background.main,
      boxShadow: 'none',
    },

    '& .MuiMenuItem-root': {
      padding: theme.spacing(0),
      background: theme.palette.sidebar.background.main,
    },

    '& .MuiDivider-root': {
      marginTop: theme.spacing(0),
      marginBottom: theme.spacing(0),
    },
  },

  navigationItem: {
    padding: theme.spacing(2.5, 3.125),
  },

  username: {
    marginRight: 'auto',
  },

  control: {
    display: 'block',
  },
}));
